import React from 'react';

import ChartRenderer from 'common/charts/ChartRenderer';

const ChartStyle = {
  // This is required to fill a gap that chartjs has at the bottom of the chart.
  // The chart's fill color does not extend fully to the bottom of the chart.
  // This inset shadow fills in that tiny gap using the same fill color.
  boxShadow: `inset 0 -1px 0 0 var(--color-gray-60)`,
};
const DefaultAspectRatio = 6;

type Props = {
  aspectRatio?: number;
  data: number[];
};

const SimpleLineChart = ({ aspectRatio = DefaultAspectRatio, data }: Props) => {
  const chartConfig = getConfig(data, {
    aspectRatio,
    borderColor: getComputedStyle(document.documentElement).getPropertyValue('--color-gray-120'),
    backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--color-gray-60'),
  });

  return (
    <div style={ChartStyle}>
      <ChartRenderer type="line" chartConfig={chartConfig} />
    </div>
  );
};

export default React.memo(SimpleLineChart);

type Options = {
  aspectRatio: number;
  borderColor: string;
  backgroundColor: string;
};

function getConfig(data: number[], { aspectRatio, borderColor, backgroundColor }: Options) {
  return {
    data: {
      labels: Object.keys(data), // labels must be the same length as the data
      datasets: [
        {
          clip: 1,
          data,
          fill: true,
          tension: 0.35,
          borderColor,
          backgroundColor,
          borderWidth: 2,
        },
      ],
    },
    options: {
      aspectRatio,
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        autoPadding: false,
        padding: {
          left: 0,
          bottom: 1,
          right: 0,
          top: 2,
        },
      },
      scales: {
        x: {
          display: false,
        },
        y: {
          display: false,
          min: 0,
          max: Math.max(...data),
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
      elements: {
        point: {
          pointStyle: false,
        },
      },
    },
  };
}
